import { render, staticRenderFns } from "./oceanday.vue?vue&type=template&id=782a33c5&scoped=true&"
import script from "./oceanday.vue?vue&type=script&lang=js&"
export * from "./oceanday.vue?vue&type=script&lang=js&"
import style0 from "./oceanday.vue?vue&type=style&index=0&lang=css&"
import style1 from "./oceanday.vue?vue&type=style&index=1&id=782a33c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782a33c5",
  null
  
)

export default component.exports